import { Component, OnInit } from "@angular/core"
import { Title } from "@angular/platform-browser"

import { GTMService } from "../services/gtm.service"
import { ActivatedRoute } from "@angular/router"
import { CookiesService } from "../services/cookies.service"
import { AuthModalComponent } from "../shared-components/modals/auth-modal/auth-modal.component"
import { StudentLoginModalComponent } from "../shared-components/modals/student-login-modal/student-login-modal.component"
import { NgbModal } from "@ng-bootstrap/ng-bootstrap"

@Component({
    templateUrl: "./signup.component.html",
    styleUrls: ["./signup.component.less"],
})
export class SignupComponent implements OnInit {
    public signUpHeadingLogo: string = ""
    public pbsLogo: string = ""
    public wgbhLogo: string = ""
    public pbsKidsLogo: string = ""
    public firstMarketingBlockLogo: string = ""
    public secondMarketingBlockLogo: string = ""
    public thirdMarketingBlockLogo: string = ""
    public fourthMarketingBlockLogo: string = ""
    public authSectionTitle: string = "Join PBS LearningMedia as a"
    public authSectionDescription: string = "Already have an account?"
    public authSectionLinkText: string = "Sign in here."
    public nextUrl: string

    constructor(
        private titleService: Title,
        private gtmService: GTMService,
        private route: ActivatedRoute,
        private cookieService: CookiesService,
        private modalService: NgbModal
    ) {
        this.titleService.setTitle(
            "Educational Resources For Teachers And Students | PBS LearningMedia"
        )
        this.gtmService.resetDataLayer()
        this.gtmService.pushPageView()
    }

    public ngOnInit(): void {
        this.route.queryParams.subscribe((params) => {
            this.nextUrl = params["next"]
            let open = params["open"]
            if (this.nextUrl) {
                this.cookieService.setCookie("next", this.nextUrl, 1, "/")
            }

            if (open) {
                if (open === "teacher") {
                    setTimeout(() => this.openAuthModal())
                } else if (open === "student") {
                    setTimeout(() => this.openStudentAuthModal())
                }
            }
        })
    }

    public openAuthModal() {
        const modalRef = this.modalService.open(AuthModalComponent)
        modalRef.componentInstance.nextURL = this.nextUrl
        modalRef.componentInstance.overrideStudentNext = !!this.nextUrl
    }

    public openStudentAuthModal() {
        const modalRef = this.modalService.open(StudentLoginModalComponent)
        modalRef.componentInstance.nextURL = this.nextUrl
        modalRef.componentInstance.overrideStudentNext = !!this.nextUrl
    }

    public scrollToTop() {
        document.querySelector("body").scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
        })
    }
}
